import TextInput from "@general-ui/text-input/text";
import { useMemo, useRef, useState } from "react";
import { useTypedSelector } from "@/store/reducers/use-typed-selector";
import { selectCurrentSeries, selectIsLoadingCurrentSeries } from "@/store/selectors/series";
import ProjectCard from "./components/project-card";
import { useHistory } from "react-router-dom";
import { useGetAdminUrl } from "@/utils/admin-routing-utils";
import { SessionPanelMap } from "../session-panel-route-map";
import { SessionPanelLayoutsTypes } from "@/types/working-model";
import Icon, { ICONS } from "@general-ui/icon";
import "./up-next-panel.scss";

export default function UpNextPanel() {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const currentSeries = useTypedSelector(selectCurrentSeries);
	const loading = useTypedSelector(selectIsLoadingCurrentSeries);
	const [searchTerm, setSearchTerm] = useState('');
	const history = useHistory();
	const adminPath = useGetAdminUrl();

	const handleSearch = (e: React.FocusEvent<HTMLInputElement, Element>) => {
		const searchValue = e.target.value;
		setSearchTerm(searchValue);
	};

	const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const searchValue = e.target.value;
		setSearchTerm(searchValue);
	};

	const handleEnter = (searchValue: string) => {
		setSearchTerm(searchValue);
	};

	const addEvent = () => {
		history.push(
			adminPath({
				path: SessionPanelMap[SessionPanelLayoutsTypes.AddEvents],
			}),
			{
				panelTitle: 'Projects'
			}
		);
	};

	const eventsList = useMemo(() => {
		return currentSeries?.events.filter(ev => ev.title.base.toLowerCase().includes(searchTerm.toLowerCase()));
	}, [currentSeries?.events, searchTerm]);

	return (
		<div
			className="session-panel up-next"
			ref={containerRef}
		>
			<div className="session-panel-header-options">
				<TextInput
					defaultValue={''}
					onChange={handleSearchChange}
					onBlur={handleSearch}
					onEnterKey={handleEnter}
					placeholder="Search..."
					className="small"
					isAdmin
				/>
			</div>
			<div
				className="session-panel-content"
			>
				{eventsList?.map(event => {
					return (
						<ProjectCard key={event.uuid} event={event} />
					);
				}) || <></>}
				<button
					className="no-style add-button"
					style={{ marginTop: 4 }}
					onClick={addEvent}
				>
					<span><Icon name={ICONS.ADD} size={12} /> Add project</span>
				</button>
			</div>
		</div>
	);
}